<template>
	<div v-loading="loadingEfect" element-loading-text="正在导出，请稍候" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="case-pice" style="display: flex;">
			<div style="width:300px">
				<span class="case-pice-first">学员信息</span> <span class="case-pice-and">/</span> <span
					class="case-pice-second">注销学员列表</span>
			</div>
		</div>
		<div style="display: flex;">
			<div class="commom-input-label-short">注销日期：</div>
			<div style="width: 300px;height: 60px;line-height: 60px;;">
				<el-date-picker v-model="applicationDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable
					size='small' type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
					class='common-full-width'></el-date-picker>
			</div>
			<div style="height: 60px;line-height: 60px;margin-left: 10px;">
				<el-button size='small' style='width: 88px;' type="primary" @click='search()' plain
					icon="el-icon-search">查询
				</el-button>
			</div>
		</div>

		<el-table :data="tableData" border style="width: 100%" stripe height=' calc(100vh - 220px)'>
			</el-table-column>
			<el-table-column label="序号" width="60">
				<template slot-scope="scope">
					{{scope.$index+1}}
				</template>
			</el-table-column>
			<el-table-column prop="name" show-overflow-tooltip label="学员姓名" min-width="150">
			</el-table-column>
			<el-table-column show-overflow-tooltip label="证件类型" min-width="150">
				<template slot-scope="scope">
					<span>{{scope.row.cardTypeData.name=="全部"?"":scope.row.cardTypeData.name}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="idCard" show-overflow-tooltip label="证件号码" min-width="150">
			</el-table-column>
			<el-table-column prop="certificationNo" show-overflow-tooltip label="学员编号" min-width="150">
			</el-table-column>
			<el-table-column show-overflow-tooltip label="性别" min-width="150">
				<template slot-scope="scope">
					<span v-if='scope.row.sex == 0'>男</span>
					<span v-if='scope.row.sex == 1'>女</span>
				</template>
			</el-table-column>
			<el-table-column prop="certificationNo" show-overflow-tooltip label="学员照片" min-width="150">
				<template slot-scope="scope">
					<div :id='"imgTooles"+scope.$index' @click="preImage(scope.$index)"
						style="text-align: center;cursor: pointer;">
						<img style="display:inline-block;height: 50px;width:50px;" :data-original='scope.row.personImg'
							:src="scope.row.personImg" alt="" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="phone" show-overflow-tooltip label="手机号码" min-width="150">
			</el-table-column>
			<el-table-column prop="delTime" show-overflow-tooltip label="注销时间" min-width="150">
			</el-table-column>
		</el-table>
		<div class="pagination-block">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10,20,50,100]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="totalNumber">
			</el-pagination>
		</div>
		<el-dialog :title="dialogTitle" :visible.sync="centerDialogVisible" width="30%" center>
			<div style="display: flex;">
				<div style="width: 80px;height: 30px;line-height: 30px;">
					学时：
				</div>
				<el-input-number size='small' style='width: 200px;' v-model="changeTimeData.period" :step="1">
				</el-input-number>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="centerDialog()">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="查询条件" :visible.sync="dialogSearchModel" v-if='dialogSearchModel' width='80%'>
			<div style="display: flex;">
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">安全证书：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.safetyStatus" clearable
							placeholder="请选择">
							<el-option v-for="item in safetyList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">证件类型：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.idType" clearable
							placeholder="请选择">
							<el-option v-for="item in cardTypeList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">证件号：</div>
					<div class="common-full-width-style">
						<el-input v-model="searchData.idCard" clearable class='common-full-width' size='small'
							placeholder="请输入证件号"></el-input>
					</div>
				</div>
			</div>
			<div style="display: flex;">
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">性别：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.sex" clearable
							placeholder="请选择性别">
							<el-option v-for="item in sexList" :key="item.code" :label="item.name" :value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">手机号：</div>
					<div class="common-full-width-style">
						<el-input v-model="searchData.phone" clearable class='common-full-width' size='small'
							placeholder="请输入手机号"></el-input>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">出生日期：</div>
					<div class="common-full-width-style">
						<el-date-picker size='small' style="width: 100%;" v-model="searchData.birthday" type="date"
							placeholder="选择出生日期"></el-date-picker>
					</div>
				</div>
			</div>
			<div style="display: flex;">
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">民族：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.nation" clearable
							placeholder="请选择">
							<el-option v-for="item in nationList" :key="item.cc" :label="item.name" :value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short" style="font-size: 13px !important;">专业技术职务</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.technicalPosition"
							clearable placeholder="请选择专业技术职务">
							<el-option v-for="item in technicalList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">通讯地址：</div>
					<div class="common-full-width-style">
						<el-input v-model="searchData.homeAddress" clearable class='common-full-width' size='small'
							placeholder="请输入通讯地址"></el-input>
					</div>
				</div>
			</div>
			<div style="display: flex;">
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">毕业院校：</div>
					<div class="common-full-width-style">
						<el-input v-model="searchData.graduateSchool" clearable class='common-full-width' size='small'
							placeholder="请输入毕业院校"></el-input>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">毕业时间：</div>
					<div class="common-full-width-style">
						<el-date-picker size='small' style="width: 100%;" v-model="searchData.graduationDate"
							type="date" placeholder="选择毕业时间"></el-date-picker>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">学历：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.education" clearable
							placeholder="请选择学历">
							<el-option v-for="item in educationList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
			</div>

			<div style="display: flex;">
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">学位：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.degree" clearable
							placeholder="请选择学位">
							<el-option v-for="item in degreeList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">考试科目：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.examSubject" clearable
							placeholder="请选择考试科目">
							<el-option v-for="item in examSubjectList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">单位名称：</div>
					<div class="common-full-width-style">
						<el-input v-model="searchData.companyName" clearable class='common-full-width' size='small'
							placeholder="请输入单位名称"></el-input>
					</div>
				</div>
			</div>
			<div style="display: flex;">
				<div class="commom-input-label-short">数据源：</div>
				<div class="common-full-width-style">
					<el-select size='small' class='common-full-width' @change='changeChannel'
						v-model="searchData.channel" clearable placeholder="请选择">
						<el-option v-for="item in channelList" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="commom-input-label-short">
					<span v-show="nowSelectChannel == 1"> 开始时间：</span>
				</div>
				<div class="common-full-width-style">
					<el-date-picker v-show="nowSelectChannel == 1" size='small' style="width: 100%;"
						v-model="searchData.graduationDate" type="datetime" placeholder="选择导入时间"></el-date-picker>
				</div>
				<div class="commom-input-label-short">
					<span v-show="nowSelectChannel == 1"> 结束时间：</span>
				</div>
				<div class="common-full-width-style">
					<el-date-picker v-show="nowSelectChannel == 1" size='small' style="width: 100%;"
						v-model="searchData.graduationDate" type="date" placeholder="选择导入时间"></el-date-picker>
				</div>
			</div>
			<div style="display: flex;">
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short" style="width: 200px;">累计从事道路运输行业年限：</div>
					<div class="common-full-width-style">
						<el-input v-model="searchData.yearsOfWorking" clearable class='common-full-width' size='small'
							placeholder="请输入累计从事道路运输行业年限"></el-input>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short" style="width: 200px;">工商（法人）注册地筛选：</div>
					<div class="common-full-width-style">
						<el-cascader style="width:100%" @change="changegeData(bigName)" size='small'
							placeholder="请选择工商（法人）注册地筛选" v-model="bigName" :options="mapData" :props="{value:'label'}">
						</el-cascader>
					</div>
				</div>
			</div>
			<div style="text-align:center;height: 50px;line-height: 50px;">
				<el-button size='small' type="primary" @click='search()' plain icon="el-icon-search">查询</el-button>
				<el-button size='small' type="info" @click='dialogSearchModel = false' plain icon='el-icon-refresh'>取消
				</el-button>
			</div>
		</el-dialog>
		<el-dialog title="批量增加学时" :visible.sync="addStudentModel" width="35%" center>
			<div style="height: 350px;overflow: auto;">
				<div style="display: flex;margin-bottom: 10px;" v-if="nowSelectDataList.length>1">
					<div style="width: 160px;height: 30px;line-height: 30px;color: #409EFF;">
						批量修改学时：
					</div>

					<el-input-number :min='0' @change='commonChange()' size='small' style='width: 200px;'
						v-model="commonPeriod" :step="1">
					</el-input-number>
				</div>
				<div style="display: flex;margin-bottom: 10px;" v-for="(item,index) in nowSelectDataList" :key='index'>
					<div style="width: 80px;height: 30px;line-height: 30px;">
						{{item.name}}
					</div>
					<div style="width: 80px;height: 30px;line-height: 30px;">
						学时：
					</div>
					<el-input-number size='small' :min='0' style='width: 200px;' v-model="item.period" :step="1">
					</el-input-number>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addStudentModel = false">取 消</el-button>
				<el-button type="primary" @click="mulAddStudent()">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="批量上传成绩" :visible.sync="addStudentGrade" width="35%" center>
			<div style="height: 300px;overflow: auto;">
				<div style="display: flex;margin-bottom: 10px;" v-for="(item,index) in nowSelectDataList" :key='index'>
					<div style="width: 80px;height: 30px;line-height: 30px;">
						{{item.name}}
					</div>
					<div style="width: 80px;height: 30px;line-height: 30px;">
						成绩：
					</div>
					<el-input-number size='small' :min='0' style='width: 200px;' v-model="item.period" :step="1">
					</el-input-number>
				</div>
			</div>
			<div style="text-align: center;height: 10px">
				<el-button type="primary" @click="importStudentTemplate()">导出学员成绩模板</el-button>
				<el-upload :headers="$util.getUploadHeaders()" style='display: inline-block;margin: 0 10px' :on-success="handleAvatarSuccess"
					:action='actionUrl' :show-file-list='false'>
					<el-button size="small" type="primary" plain>导入学员成绩</el-button>
				</el-upload>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addStudentGrade = false">取 消</el-button>
				<el-button type="primary" @click="mulAddStudent()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios';
	import Viewer from 'viewerjs';
	import map from '@/common/js/map.js'
	import {
		studentList,
		graduationStudent,
		majorTypeList,
		exportExcel,
		PersonImages,
		period,
		templateUrl,
		getCancelList,
	} from '../../api/main'
	export default {
		data() {
			return {
				delEndTime:'',
				delStartTime:'',
				commonPeriod: 0,
				addStudentModel: false,
				addStudentGrade: false,
				mapData: map,
				safetyList: [{
					label: '全部',
					value: ''
				}, {
					label: '是',
					value: '1'
				}, {
					label: '否',
					value: '0'
				}],
				dialogSearchModel: false,
				loadingEfect: false,
				channelList: [{
					label: '全部',
					value: ''
				}, {
					label: '线上报名',
					value: '0'
				}, {
					label: '线下导入',
					value: '1'
				}],
				// actionUrl: 'https://daoxie.hellouxing.com/admin/import/excel/student',
				actionUrl: '',
				applicationDate: '',
				completeDate: '',
				searchData: {
					certificationNo: '',
					name: '',
					professionalClasses: '',
					trainers: '',
					trainingClasses: '',
					trainingStatus: '',
					channel: '',
					isUploadPersonImg: '',
					applicationDateStart: '',
					applicationDateEnd: '',
					completeDateStart: '',
					completeDateEnd: '',
					safetyStatus: '',
					degree: '', //学位
					major: '', //专业
					graduationDate: '', //毕业时间
					graduateSchool: '', //毕业院校
					homeAddress: '', //通讯地址
					email: '', //邮箱
					technicalPosition: '', //专业技术职务
					nation: '', //民族
					idType: '', //证件类型
					birthday: '', //出生日期
					registrationPlace: '', //工商（法人）注册
					postcode: '', //邮编
					recipientsPhone: '', //联系电话
					recipients: '', //收件人
					mailingAddress: '', //证书邮寄地址
					employedDate: '', //受雇日期
					yearsOfWorking: '', //累计从事道路运输工作年限
					companyContacts: '', //企业联系人
					companyContactsPhone: '', //企业联系人电话
					examSubject: '', //考试科目
					idCard: '',
					sex: '',
					education: '',
					companyName: '',
					kaohezhuangtai: ''
				},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				totalNumber: 0,
				isUploadPersonImglist: [{
					label: '全部',
					value: ''
				}, {
					label: '未上传',
					value: '0'
				}, {
					label: '已上传',
					value: "1"
				}],
				tarinStatusList: [{
					label: '全部',
					value: ''
				}, {
					label: '培训中',
					value: '1'
				}, {
					label: '考核中',
					value: '3'
				}, {
					label: '结业',
					value: "2"
				}],
				tarinTypeList: [{
					label: '全部',
					value: ''
				}, {
					label: '初次培训',
					value: '1'
				}, {
					label: '继续教育',
					value: "2"
				}],
				exmaList: [{
					label: '全部',
					value: ''
				}, {
					label: '缺考',
					value: '1'
				}, {
					label: '未通过',
					value: "2"
				}, {
					label: '通过',
					value: "3"
				}],
				majorCategoryList: [],
				trainersList: [{
					label: '全部',
					value: ''
				}, {
					label: '负责人',
					value: "1"
				}, {
					label: '安全管理人员',
					value: "2"
				},
				 {
					label: '动态监控',
					value: "3"
				}, {
					label: '其他',
					value: "4"
				}],
				stateList: [{
					label: '全部',
					value: ''
				}, {
					label: '未审核',
					value: '1',
				}, {
					label: '已取消',
					value: "0",
				}, {
					label: '审核通过',
					value: "2",
				}, {
					label: '审核驳回',
					value: "3",
				}],
				nowSelectDataList: [],
				centerDialogVisible: false,
				dialogTitle: '',
				changeTimeData: {
					applicationFormIds: [],
					period: 0,
					type: 0

				},
				importUrl: '',
				provinceName: '',
				cityName: '',
				countyName: '',
				bigName: '',
				nowSelectChannel: '',
			}
		},
		activated() {
			this.getStudentList();
			this.getMajorDataList();
			templateUrl().then(res => {
				console.log(res)
				this.importUrl = res.data;
			})
		},
		mounted() {
			this.actionUrl = `${this.$httpUrl}/admin/import/excel/student`
			this.getStudentList();
			this.getMajorDataList();
			templateUrl().then(res => {
				console.log(res)
				this.importUrl = res.data;
			})
		},
		computed: {
			cardTypeList() {
				let cardTypeList = JSON.parse(sessionStorage.getItem('cardTypeList'));
				return cardTypeList;
			},
			sexList() {
				let sexList = [{
					name: '全部',
					code: ''
				}, {
					name: '男',
					code: 0
				}, {
					name: '女',
					code: 1
				}];
				return sexList;
			},
			nationList() {
				let nationList = JSON.parse(sessionStorage.getItem('nationList'));
				return nationList;
			},
			technicalList() {
				let technicalList = JSON.parse(sessionStorage.getItem('technicalList'));
				return technicalList;
			},
			educationList() {
				let educationList = JSON.parse(sessionStorage.getItem('educationList'));
				return educationList;
			},
			degreeList() {
				let degreeList = JSON.parse(sessionStorage.getItem('degreeList'));
				return degreeList;
			},
			examSubjectList() {
				let examSubjectList = JSON.parse(sessionStorage.getItem('examSubjectList'));
				return examSubjectList;
			},
		},
		methods: {
			cancelSign(row) {
				this.$confirm('您确定要注销此学员账户吗？注销账户后请及时操作退款。？', '注销确认', {
					confirmButtonText: '确定注销',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '注销成功'
					});
					// graduationStudent(arr).then(res => {
					// 	if (res.code == 1) {
					// 		this.$message({
					// 			type: 'success',
					// 			message: '结业成功'
					// 		});
					// 		this.search();
					// 	} else {
					// 		this.$message({
					// 			type: 'error',
					// 			message: res.msg
					// 		});
					// 	}
					// })
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消结业操作'
					// });
				});
			},
			changeChannel(value) {
				console.log(value)
				this.nowSelectChannel = value;
			},
			exportStudentBook() {
				if (this.nowSelectDataList.length == 0) {
					this.$message.warning('请选择您想要导出任命书的学员');
					return;
				}
				var dateStr = '';
				var dateStrTwo = '';
				if (this.$util.getNowDate(this.applicationDate[0])) {
					var dateStr = this.$util.getNowDate(this.applicationDate[0]) + ',' + this.$util.getNowDate(this
						.applicationDate[1]);
					this.searchData.applicationDateStart = this.$util.getNowDate(this.applicationDate[0])
					this.searchData.applicationDateEnd = this.$util.getNowDate(this.applicationDate[1])
				}
				if (this.$util.getNowDate(this.completeDate[0])) {
					var dateStrTwo = this.$util.getNowDate(this.completeDate[0]) + ',' + this.$util.getNowDate(this
						.completeDate[1]);
					this.searchData.completeDateStart = this.$util.getNowDate(this.completeDate[0])
					this.searchData.completeDateEnd = this.$util.getNowDate(this.completeDate[1])
				}
				// this.searchData.applicationDate = dateStr;
				// this.searchData.completeDate = dateStrTwo;
				this.loadingEfect = true;
				let arr = [];
				this.nowSelectDataList.forEach((item, index) => {
					arr.push(item.studentId)
				})
				axios({
					// responseType: 'blob',
					url: `${this.$httpUrl}/admin/download/PersonImages`,
					headers: {
						'Content-Type': 'application/json'
					},
					method: 'post',
					data: arr
				}).then(res => {
					console.log(res.data)
					if (res.data.code == '1') {
						window.open(res.data.data)
						this.$message.success('导出成功！')
						this.loadingEfect = false;
					} else {
						this.$message.error('导出失败，请重试！')
						this.loadingEfect = false;
					}
					// const link = document.createElement('a')
					// let blob = new Blob([res.data], {
					// 	type: 'application.zip'
					// })
					// link.style.display = 'none'
					// link.href = URL.createObjectURL(blob)
					// link.setAttribute('download', '学员照片列表.zip')
					// document.body.appendChild(link)
					// link.click()
					// URL.revokeObjectURL(link.href);
					// document.body.removeChild(link)
					// this.loadingEfect = false;
					// this.$message.success('导出成功！')
				})
			},
			mulUpload() {
				if (this.nowSelectDataList.length == 0) {
					this.$message.warning('请选择您想要修改成绩的学员');
					return;
				}
				this.addStudentGrade = true;
			},
			importStudentTemplate() {
				var dateStr = '';
				if (this.$util.getNowDate(this.applicationDate[0])) {
					// var dateStr = this.$util.getNowDate(this.applicationDate[0]) + ',' + this.$util.getNowDate(
					// 	this.applicationDate[1]);
					this.searchData.applicationDateStart = this.$util.getNowDate(this.applicationDate[0])
					this.searchData.applicationDateEnd = this.$util.getNowDate(this.applicationDate[1])
				}
				// this.applicationDate = dateStr
				if (this.nowSelectDataList.length == 0) {
					this.$message.error('请选择您想要导出的学员数据');
					return;
				}
				let arrList = [];
				this.loadingEfect = true;
				this.nowSelectDataList.forEach((item) => {
					arrList.push(item.applicationFormId)
				})
				// let arrI
				axios({
					responseType: 'blob',
					url: `${this.$httpUrl}/admin/applicationForm/list/excel`,
					headers: {
						'Content-Type': 'application/json'
					},
					method: 'post',
					data: arrList
				}).then(res => {
					console.log(res)
					const link = document.createElement('a')
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					})
					link.style.display = 'none'
					link.href = URL.createObjectURL(blob)
					link.setAttribute('download', '报名记录列表.xlsx')
					document.body.appendChild(link)
					link.click()
					URL.revokeObjectURL(link.href);
					document.body.removeChild(link)
					this.loadingEfect = false;
					this.$message.success('导出成功！')
				})
			},
			mulAddStudent() {
				// this.nowSelectDataList.forEach((item, index) => {
				// 	item.period = this.commonPeriod
				// })
				console.log(this.nowSelectDataList)
				// graduationStudent(arr).then(res => {
				// 	if (res.code == 1) {
				// 		this.$message({
				// 			type: 'success',
				// 			message: '添加学时成功'
				// 		});
				// 		this.search();
				// 	} else {
				// 		this.$message({
				// 			type: 'error',
				// 			message: res.msg
				// 		});
				// 	}
				// })
			},
			commonChange() {
				console.log(this.commonPeriod)
				if (this.commonPeriod >= 0) {
					this.nowSelectDataList.forEach((item, index) => {
						item.period = this.commonPeriod
					})
				}

			},
			muladdStudentTime() {
				if (this.nowSelectDataList.length == 0) {
					this.$message.warning('请选择您想要增加学时的学员');
					return;
				}
				this.addStudentModel = true;
			},
			changegeData(value) {
				console.log(value)
				if (value.length == 2) {
					this.provinceName = value[0];
					this.cityName = value[0];
					this.countyName = value[1];
				} else {
					this.provinceName = value[0];
					this.cityName = value[1];
					this.countyName = value[2];
				}
			},
			getRowKeys(row) {
				return row.applicationFormId;
			},
			allGraduate() {
				if (this.nowSelectDataList.length == 0) {
					this.$message.warning('请选择您想要结业的学员');
					return;
				}
				let arr = [];
				this.nowSelectDataList.forEach((item, index) => {
					arr.push(item.studentId)
				})
				this.$confirm('确定要将该学员结业吗？', '结业确认', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					graduationStudent(arr).then(res => {
						if (res.code == 1) {
							this.$message({
								type: 'success',
								message: '结业成功'
							});
							this.search();
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消结业操作'
					});
				});
			},
			handleAvatarSuccess(res, file) {
				if (res.code == 1) {
					this.$message.success('导入成功！')
				} else {
					this.$message.error(res.msg)
				}
			},
			exportTemplate() {
				const link = document.createElement('a')
				link.style.display = 'none'
				link.href = this.importUrl
				link.setAttribute('download', '学员导入模板.xlsx')
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			},
			centerDialog() {
				this.changeTimeData.applicationFormIds = [];
				this.nowSelectDataList.forEach((item, index) => {
					this.changeTimeData.applicationFormIds.push(item.applicationFormId)
				})
				period(this.changeTimeData).then(res => {
					console.log(res)
					if (res.code == 1) {
						this.$message({
							type: 'success',
							message: '学时修改成功'
						});
						this.centerDialogVisible = false;
						this.search();
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						});
					}
				})
			},
			changeStudentTime(type) {
				if (type == 1) {
					this.dialogTitle = '加学时'
				} else {
					this.dialogTitle = '减学时'
				}

				if (this.nowSelectDataList.length == 0) {
					this.$message.warning('请选择您想要修改学时的学员');
					return;
				}
				this.centerDialogVisible = true;
				this.changeTimeData.type = type;
				this.changeTimeData.period = 0;
			},
			handleSelectionChange(data) {
				console.log(data)
				this.nowSelectDataList = data;
			},
			exportAllData() {
				if (this.nowSelectDataList.length == 0) {
					this.$message.warning('请选择您想要导出图片的学员');
					return;
				}
				var dateStr = '';
				var dateStrTwo = '';
				if (this.$util.getNowDate(this.applicationDate[0])) {
					var dateStr = this.$util.getNowDate(this.applicationDate[0]) + ',' + this.$util.getNowDate(this
						.applicationDate[1]);
					this.searchData.applicationDateStart = this.$util.getNowDate(this.applicationDate[0])
					this.searchData.applicationDateEnd = this.$util.getNowDate(this.applicationDate[1])
				}
				if (this.$util.getNowDate(this.completeDate[0])) {
					var dateStrTwo = this.$util.getNowDate(this.completeDate[0]) + ',' + this.$util.getNowDate(this
						.completeDate[1]);
					this.searchData.completeDateStart = this.$util.getNowDate(this.completeDate[0])
					this.searchData.completeDateEnd = this.$util.getNowDate(this.completeDate[1])
				}
				// this.searchData.applicationDate = dateStr;
				// this.searchData.completeDate = dateStrTwo;
				this.loadingEfect = true;
				let arr = [];
				this.nowSelectDataList.forEach((item, index) => {
					arr.push(item.studentId)
				})
				axios({
					// responseType: 'blob',
					url: `${this.$httpUrl}/admin/download/PersonImages`,
					headers: {
						'Content-Type': 'application/json'
					},
					method: 'post',
					data: arr
				}).then(res => {
					console.log(res.data)
					if (res.data.code == '1') {
						window.open(res.data.data)
						this.$message.success('导出成功！')
						this.loadingEfect = false;
					} else {
						this.$message.error('导出失败，请重试！')
						this.loadingEfect = false;
					}
					// const link = document.createElement('a')
					// let blob = new Blob([res.data], {
					// 	type: 'application.zip'
					// })
					// link.style.display = 'none'
					// link.href = URL.createObjectURL(blob)
					// link.setAttribute('download', '学员照片列表.zip')
					// document.body.appendChild(link)
					// link.click()
					// URL.revokeObjectURL(link.href);
					// document.body.removeChild(link)
					// this.loadingEfect = false;
					// this.$message.success('导出成功！')
				})
			},
			preImage(index) {
				const ViewerDom = document.getElementById('imgTooles' + index);
				const viewer = new Viewer(ViewerDom, {
					url: "data-original"
				});
			},
			getMajorDataList() {
				majorTypeList({
					current: 1,
					pageSize: 30,
					professionalName: ''
				}).then(res => {
					this.majorCategoryList = res.data.records;
					this.majorCategoryList.unshift({
						codeCname: '全部',
						codeCode: ''
					})
				})
			},
			getStudentList() {
				var dateStr = '';
				var dateStrTwo = '';
				if (this.applicationDate) {
					var dateStr = this.$util.getNowDate(this.applicationDate[0]) + ',' + this.$util.getNowDate(this
						.applicationDate[1]);
					this.delStartTime =  this.$moment(this.applicationDate[0]).format("YYYY-MM-DD");
					this.delEndTime = this.$moment(this.applicationDate[1]).format("YYYY-MM-DD");
				}else{
					this.delStartTime = ''
					this.delEndTime = ''
				}
				this.searchData.pageSize = this.pageSize;
				this.searchData.current = this.currentPage;
				getCancelList({delStartTime:this.delStartTime,delEndTime:this.delEndTime}).then(res => {
					this.tableData = res.data.records;
					this.tableData.forEach((item) => {
						item.degreeData = this.degreeList.find((value) => value.code == item
							.trainingClasses);
						item.cardTypeData = this.cardTypeList.find((value) => value.code == item.idType);
						item.nationData = this.nationList.find((value) => value.code == item.nation);
						item.technicalData = this.technicalList.find((value) => value.code == item
							.technicalPosition);
						item.professionalData = this.majorCategoryList.find((value) => value.codeCode ==
							item.professionalClasses);
						item.examSubjectData = this.examSubjectList.find((value) => value.code == item
							.examSubject);
						item.educationData = this.educationList.find((value) => value.code == item
							.education);
						item.createTime = this.$moment(item.createTime).format("YYYY-MM-DD");
						// item.createTime = this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
					})
					this.totalNumber = parseInt(res.data.total);
				})
			},
			search() {
				this.currentPage = 1;
				this.getStudentList();
				this.dialogSearchModel = false;
			},
			handleSizeChange(data) {
				this.pageSize = data;
				this.getStudentList();
			},
			handleCurrentChange(data) {
				this.currentPage = data;
				this.getStudentList();
			},
			gruduationSign(row) {
				let arr = [];
				arr.push(row.studentId)
				this.$confirm('确定要将该学员结业吗？', '结业确认', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					graduationStudent(arr).then(res => {
						if (res.code == 1) {
							this.$message({
								type: 'success',
								message: '结业成功'
							});
							this.search();
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消结业操作'
					});
				});
			},
			lookSign(text, row) {
				this.$store.state.studentId = row.studentId.toString();

				this.$router.push({
					path: '/StudentDetail',
					query: {
						applicationFormId: row.applicationFormId
					}
				})
			},
			editSign(text, row) {
				this.$store.state.editStudentId = row.studentId.toString();
				this.$router.push('/EditStudentInfoPage')
			},
			exportTable() {
				if (this.nowSelectDataList.length == 0) {
					this.$message.error('请选择您想要导出的学员数据');
					return;
				}
				let arrList = [];
				this.loadingEfect = true;
				this.nowSelectDataList.forEach((item) => {
					arrList.push(item.studentId)
				})
				axios({
					responseType: 'blob',
					url: `${this.$httpUrl}/admin/student/list/excel`,
					headers: {
						'Content-Type': 'application/json'
					},
					method: 'post',
					data: arrList
				}).then(res => {
					console.log(res)
					const link = document.createElement('a')
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					})
					link.style.display = 'none'
					link.href = URL.createObjectURL(blob)
					link.setAttribute('download', '学员信息列表.xlsx')
					document.body.appendChild(link)
					link.click()
					URL.revokeObjectURL(link.href);
					document.body.removeChild(link)
					this.loadingEfect = false;
					this.$message.success('导出成功！')
				})
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
		}
	}
</script>

<style lang="less">

</style>
